<template>
  <v-tooltip location="bottom">
    <template #activator="{ props }">
      <v-btn-icon
        icon="mdi-delete-forever"
        v-bind="props"
        class="px-sm-5 px-4"
        data-testid="deleteItem.delete-button"
        @click="showDeleteDialog = true"
      >
      </v-btn-icon>
    </template>
    <span>Delete Statechart</span>
  </v-tooltip>
  <statechart-delete-dialog
    v-if="showDeleteDialog && statechartName"
    :statechart-model-id="statechartModelId"
    :statechart-name="statechartName"
    @cancel="showDeleteDialog = false"
    @deleted="statechartDeleted"
  ></statechart-delete-dialog>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import StatechartDeleteDialog from "../../statecharts/StatechartDeleteDialog.vue";
import { ModelEventBus, ModelLoaded, WizardEventBus } from "../../../event-bus";
import { editorStateStore } from "../../services/storage/editor-state-store";

const showDeleteDialog = ref(false);
const statechartModelId = ref<string>(null);
const statechartName = ref<string>(null);

onMounted(() => {
  ModelEventBus.on("modelLoaded", setStatechart);
  ModelEventBus.on("modelIdCreated", setModelId);
});

onBeforeUnmount(() => {
  ModelEventBus.off("modelLoaded", setStatechart);
  ModelEventBus.off("modelIdCreated", setModelId);
});

function setModelId() {
  statechartModelId.value = editorStateStore().getModelId;
}

function setStatechart(event: ModelLoaded) {
  statechartModelId.value = editorStateStore().getModelId;
  statechartName.value = event.statechart?.getName() || "No Title";
}

function statechartDeleted() {
  showDeleteDialog.value = false;
  WizardEventBus.emit("forceSelectingStatechart");
}
</script>
